import React, { useEffect } from 'react';

const FullScreenImage = ({ mediaUrl, onClose, title, type }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-label={title}
        >
            {type === 'video' ? (
                <video
                    src={mediaUrl}
                    controls
                    autoPlay
                    className="max-w-full max-h-full rounded-xl"
                    onClick={(event) => event.stopPropagation()}
                >
                    Your browser does not support the video tag.
                </video>
            ) : (
                <img
                    src={mediaUrl}
                    alt={title}
                    className="max-w-full max-h-full rounded-xl"
                    onClick={(event) => event.stopPropagation()}
                />
            )}
        </div>
    );
};

export default FullScreenImage;